const bgAdviceLight = "/assets/contact/card-1-light.webp";
const bgAdviceDark = "/assets/contact/card-1.webp";
const bgInsightsLight = "/assets/contact/card-2-light.webp";
const bgInsightsDark = "/assets/contact/card-2.webp";
const bgNoCommitLight = "/assets/contact/card-3-light.webp";
const bgNoCommitDark = "/assets/contact/card-3.webp";

const bookingDark = "/assets/contact/booking.webp";
const bookingLight = "/assets/contact/booking-light.webp";
const timezonesDark = "/assets/contact/timezones.webp";
const timezonesLight = "/assets/contact/timezones-light.webp";
const realtimeDark = "/assets/contact/realtime.webp";
const realtimeLight = "/assets/contact/realtime-light.webp";

const expert1 = "/assets/contact/Wihanga.webp";
const expert2 = "/assets/contact/Dinuka.webp";
const expert3 = "/assets/contact/Dilan.webp";
const expert4 = "/assets/contact/Bhanuka.webp";
const expert5 = "/assets/contact/Mahel.webp";
const expert6 = "/assets/contact/Jayani.webp";
const expert7 = "/assets/contact/Chamudi.webp";
const expert8 = "/assets/contact/Sandali.webp";
const expert9 = "/assets/contact/Shakya.webp";
const expert10 = "/assets/contact/Dinithi.webp";

const locationSL = "/assets/contact/location_SL.webp";
const locationUS = "/assets/contact/location_US.webp";
const location = "/assets/contact/location.webp";

export const EXPERTS = [
  {
    icon: expert3,
    title: "Software Engineer – System Architecture",
    name: "Dilan Madusanka",
    imgClass:
      "mt-[-2px] mobile:mt-[-6px] ml-1 mobile:ml-3 scale-111 mobile:scale-112",
  },
  {
    icon: expert4,
    title: "Software Engineer – Product & AI Development",
    name: "Bhanuka Lakshitha",
    imgClass:
      "mt-[-6px] mobile:mt-[-12px] ml-2 mobile:ml-3 scale-111 scale-112",
  },
  {
    icon: expert1,
    title: "Co-Founder & Growth Partner",
    name: "Wihanga Jayalath",
    imgClass:
      "mt-[8px] mobile:mt-[14px] sm:mt-[20px] laptop:mt-[26px] scale-113",
  },
  {
    icon: expert2,
    title: "Co-Founder & Growth Partner",
    name: "Dinuka Wijesinghe",
    imgClass:
      "mt-[0px] mobile:mt-[4px] sm:mt-[0px] laptop:mt-[6px] sm:ml-2 laptop:ml-[12px] 3xl:ml-[12px] scale-124",
    shouldZoom: true,
  },
  {
    icon: expert5,
    title: "Software Engineer – Mobile & Emerging Platforms ",
    name: "Mahel Chandupa",
    imgClass:
      "mt-[-6px] mobile:mt-[-12px] ml-2 mobile:ml-3 scale-111 scale-112",
  },
  {
    icon: expert6,
    title: "UI/UX Designer – Digital Experience",
    name: "Jayani Jayasinghe",
    imgClass: "mt-[-4px] md:mt-[-8px] scale-112",
    shouldZoom: true,
  },
  {
    icon: expert7,
    title: "UI/UX Designer – Interface Systems",
    name: "Chamudi Rumanda",
    imgClass: "mt-[-2px] md:mt-[-6px] ml-1 laptop:ml-2 scale-124",
    shouldZoom: true,
  },
  {
    icon: expert8,
    title: "Business Analyst",
    name: "Sandali Kavindya",
    imgClass: "mt-[-4px] md:mt-[-8px] ml-1 laptop:ml-2 scale-120",
    shouldZoom: true,
  },
  {
    icon: expert9,
    title: "Delivery Manager",
    name: "Shakya Pinnawala",
    imgClass: " ml-1 mobile:ml-1 scale-114",
    bgLeft: "w-1",
  },
  {
    icon: expert10,
    title: "Quality Engineer",
    name: "Dinithi Nimesha",
    imgClass: "mt-[0px] scale-105",
  },
];

export const EXCELLENCE_CARDS = [
  {
    id: "advice",
    title: "Personalized Expert Advice",
    body: "Our specialists analyze your business needs and provide tailored recommendations based on industry best practices and emerging technologies",
    lightBg: bgAdviceLight,
    darkBg: bgAdviceDark,
  },
  {
    id: "insights",
    title: "Strategic Insights Tailored to Your Business",
    body: "We focus on your specific goals, challenges, and opportunities, delivering actionable insights that align with your vision and growth strategy",
    lightBg: bgInsightsLight,
    darkBg: bgInsightsDark,
  },
  {
    id: "no-commitment",
    title: "No Commitment Required",
    body: "This session is purely advisory. There are no obligations-just valuable guidance to help you explore the best digital solutions for your business",
    lightBg: bgNoCommitLight,
    darkBg: bgNoCommitDark,
  },
];

export const FEATURE_CARDS = [
  {
    id: "booking",
    lightBg: bookingLight,
    darkBg: bookingDark,
    line1: "Confirmation email upon",
    line2: "Booking",
  },
  {
    id: "timezones",
    lightBg: timezonesLight,
    darkBg: timezonesDark,
    line1: "Time zone selection for",
    line2: "International clients",
  },
  {
    id: "realtime",
    lightBg: realtimeLight,
    darkBg: realtimeDark,
    line1: "Embedded calendar for",
    line2: "Real-time scheduling",
  },
];

export const FAQS = [
  {
    question: "How long does it take to receive a response?",
    answer: "We typically respond within 24 hours on business days.",
  },
  {
    question: "Can I schedule a free consultation?",
    answer:
      "Yes, you can book an appointment using our online scheduling tool.",
  },
  {
    question: "Do you provide ongoing support after project complete?",
    answer: "Absolutely. We offer long-term support and maintenance solutions.",
  },
  {
    question: "What industries do you specialize in?",
    answer: "We work with businesses in finance, healthcare, e-commerce",
  },
  {
    question: "Can I visit one of your offices?",
    answer:
      "Yes! Our offices are open for scheduled visits. Please contact  us. ",
  },
  {
    question: "Do you work with startups and enterprise businesses?",
    answer: "Yes, we collaborate with startups, SMEs, and large enterprises",
  },
];

export const LOCATIONS = [
  {
    id: "usa",
    image: locationUS,
    name: "New York, USA",
    phone: "+1 (917) 719-4498",
    address: "ICIEOS LLC, 224 W 35th St Ste 500, #2395, New York, NY 10001",
    hours: "Open now (08.00AM - 05.00PM)",
    position: {
      default: { top: "46%", left: "25.5%" },
      mobile: { top: "48.5%", left: "25.5%" },
      sm: { top: "48%", left: "26.5%" },
      md: { top: "47.5%", left: "27%" },
      lg: { top: "48%", left: "28.5%" },
      xl: { top: "48%", left: "28.5%" },
      laptop: { top: "48%", left: "28%" },
      "3xl": { top: "48%", left: "28.5%" },
    },
    popupPosition: {
      default: "right",
      sm: "right",
      md: "right",
      lg: "right",
      xl: "right",
      laptop: "right",
    },
  },
  // {
  //   id: "uk",
  //   image: location,
  //   name: "London, UK",
  //   phone: "+44 123 456 789",
  //   address:
  //     "2 Arcade Chamber, Bradford street, Walsall, WS1 1PQ ",
  //   hours: "Open now (08.00AM - 05.00PM)",
  //   position: {
  //     default: { top: "37%", left: "44%" },
  //     mobile: { top: "39%", left: "44%" },
  //     sm: { top: "40%", left: "44.5%" },
  //     md: { top: "39.5%", left: "44.5%" },
  //     lg: { top: "40%", left: "45%" },
  //     xl: { top: "40.5%", left: "45%" },
  //     laptop: { top: "40%", left: "45%" },
  //     "3xl": { top: "39.5%", left: "45%" },
  //   },
  //   popupPosition: {
  //     default: "above",
  //     sm: "right",
  //     md: "right",
  //     lg: "right",
  //     xl: "right",
  //     laptop: "right",
  //     "3xl": "right",
  //   },
  // },
  {
    id: "lk",
    image: locationSL,
    name: "Colombo, SL",
    phone: "+94705678008",
    address:
      "ICIEOS, Level 35, West Tower, World Trade Center, Colombo 01, Sri Lanka. 00100",
    hours: "Open now (08.00AM - 05.00PM)",
    position: {
      default: { top: "64%", left: "67.5%" },
      mobile: { top: "64%", left: "67.5%" },
      sm: { top: "63.5%", left: "66%" },
      md: { top: "64%", left: "66%" },
      lg: { top: "64%", left: "65%" },
      xl: { top: "64.5%", left: "65%" },
      laptop: { top: "64.5%", left: "65%" },
      "3xl": { top: "64.5%", left: "65.5%" },
    },
    popupPosition: {
      default: "above",
      sm: "above",
      md: "above",
      lg: "above",
      xl: "above",
      laptop: "above",
    },
  },
  // {
  //   id: "aus",
  //   image: location,
  //   name: "Queensland, AUS",
  //   phone: "+61 234 567 890",
  //   address: "416/977, Ann Street, Fortitude Valley, QLD 4006, Australia",
  //   hours: "Open now (08.00AM - 05.00PM)",
  //   position: {
  //     default: { top: "77%", left: "84%" },
  //     mobile: { top: "77.5%", left: "85%" },
  //     sm: { top: "76%", left: "84%" },
  //     md: { top: "76.5%", left: "83.5%" },
  //     lg: { top: "76.5%", left: "82%" },
  //     xl: { top: "76.5%", left: "81%" },
  //     laptop: { top: "77%", left: "81%" },
  //     "3xl": { top: "76.5%", left: "81.5%" },
  //   },
  //   popupPosition: {
  //     default: "above",
  //     sm: "above",
  //     md: "above",
  //     lg: "above",
  //     xl: "above",
  //     laptop: "above",
  //   },
  // },
];

export const SUBJECT_OPTIONS = [
  "General Inquiry",
  "Technical Support",
  "Partnership Request",
  "Bug Report",
  "Feature Request",
  "Other",
];
